import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { msalInstance } from '@/authConfig';
import ProtectedRoute from '@/components/ProtectedRoute';
import { Layout } from '@/components/Layout';
import Login from '@/pages/Login';
import Home from '@/pages/Home';
import Engineering from '@/pages/Engineering';
import MapPage from '@/pages/Map';
import {
  // EventsPage,
  ResourcesPage
} from '@/pages/Placeholder';
import DesignsPage from '@/pages/Designs';
import MarketingPage from '@/pages/Marketing';
import BusinessesPage from '@/pages/Admin';
import GeofencesPage from '@/pages/Admin/geofences/GeofencesPage';
import DocumentsPage from '@/pages/Documents';
import B2BPage from '@/pages/B2B';
import SocialsPage from '@/pages/Socials';
import AnalyticsPage from '@/pages/Analytics';
import FriendAnalyticsPage from '@/pages/Analytics/friends';
import UserFriendsPage from '@/pages/Analytics/friends/detail/UserFriendsPage';
import ReferralAnalyticsPage from '@/pages/Analytics/referrals';
import UserReferralsPage from '@/pages/Analytics/referrals/detail/UserReferralsPage';
import ReferredUserPage from '@/pages/Analytics/referrals/detail/ReferredUserPage';
import AttributionPage from '@/pages/Socials/attribution';
import StatSheetsPage from '@/pages/Socials/stat-sheets';
import NotificationMetricsPage from '@/pages/B2B/notification-metrics';
import BusinessAnalyticsPage from '@/pages/B2B/business-analytics';
import BusinessDetailPage from '@/pages/B2B/business-analytics/detail/BusinessDetailPage';
import FullReportPage from '@/pages/B2B/business-analytics/full-report';
import UserInsightsPage from '@/pages/B2B/user-insights';
import {
  EventReportsListPage,
  EventReportBuilderPage,
} from '@/pages/B2B/event-reports';
import CRMPage, { VenueDetailPage, CalendarPage } from '@/pages/B2B/crm';
import MarketsPage from '@/pages/Marketplace/markets/MarketsPage';
import UnassignedBusinessesPage from '@/pages/Marketplace/markets/UnassignedBusinessesPage';
import SurgePricingPage from '@/pages/Marketplace/surge-pricing/SurgePricingPage';
import AuditLogPage from '@/pages/Marketplace/surge-pricing/AuditLogPage';

function App(): React.ReactElement {
  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <Routes>
          {/* Login route - no protection needed */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes */}
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <Layout>
                  <Home />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/map" 
            element={
              <ProtectedRoute>
                <Layout>
                  <MapPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          {/* <Route 
            path="/events" 
            element={
              <ProtectedRoute>
                <Layout>
                  <EventsPage />
                </Layout>
              </ProtectedRoute>
            } 
          /> */}
          <Route 
            path="/documents" 
            element={
              <ProtectedRoute>
                <Layout>
                  <DocumentsPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/resources" 
            element={
              <ProtectedRoute>
                <Layout>
                  <ResourcesPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketing" 
            element={
              <ProtectedRoute>
                <Layout>
                  <MarketingPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/designs" 
            element={
              <ProtectedRoute>
                <Layout>
                  <DesignsPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/engineering" 
            element={
              <ProtectedRoute>
                <Layout>
                  <Engineering />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route
            path="/b2b"
            element={
              <ProtectedRoute>
                <Layout>
                  <B2BPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/b2b/notification-metrics"
            element={
              <ProtectedRoute>
                <Layout>
                  <NotificationMetricsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/b2b/user-insights"
            element={
              <ProtectedRoute>
                <Layout>
                  <UserInsightsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/b2b/business-analytics"
            element={
              <ProtectedRoute>
                <Layout>
                  <BusinessAnalyticsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/b2b/business-analytics/full-report"
            element={
              <ProtectedRoute>
                <Layout>
                  <FullReportPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/b2b/business-analytics/:businessId"
            element={
              <ProtectedRoute>
                <Layout>
                  <BusinessDetailPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/b2b/event-reports"
            element={
              <ProtectedRoute>
                <Layout>
                  <EventReportsListPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/b2b/event-reports/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <EventReportBuilderPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/b2b/crm"
            element={
              <ProtectedRoute>
                <Layout>
                  <CRMPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/b2b/crm/calendar"
            element={
              <ProtectedRoute>
                <Layout>
                  <CalendarPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/b2b/crm/venues/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <VenueDetailPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/b2b/crm/venues/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <VenueDetailPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <Layout>
                  <AnalyticsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics/friends"
            element={
              <ProtectedRoute>
                <Layout>
                  <FriendAnalyticsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics/friends/:userId"
            element={
              <ProtectedRoute>
                <Layout>
                  <UserFriendsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics/referrals"
            element={
              <ProtectedRoute>
                <Layout>
                  <ReferralAnalyticsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics/referrals/users/:userId"
            element={
              <ProtectedRoute>
                <Layout>
                  <UserReferralsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics/referrals/referred/:userId"
            element={
              <ProtectedRoute>
                <Layout>
                  <ReferredUserPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/socials"
            element={
              <ProtectedRoute>
                <Layout>
                  <SocialsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/socials/attribution"
            element={
              <ProtectedRoute>
                <Layout>
                  <AttributionPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/socials/stat-sheets"
            element={
              <ProtectedRoute>
                <Layout>
                  <StatSheetsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/businesses"
            element={
              <ProtectedRoute>
                <Layout>
                  <BusinessesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/geofences"
            element={
              <ProtectedRoute>
                <Layout>
                  <GeofencesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/markets"
            element={
              <ProtectedRoute>
                <Layout>
                  <MarketsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/markets/unassigned"
            element={
              <ProtectedRoute>
                <Layout>
                  <UnassignedBusinessesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/surge-pricing"
            element={
              <ProtectedRoute>
                <Layout>
                  <SurgePricingPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/surge-pricing/audit"
            element={
              <ProtectedRoute>
                <Layout>
                  <AuditLogPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Catch-all route for undefined pages */}
          <Route 
            path="*" 
            element={
              <ProtectedRoute>
                <Layout>
                  <Home />
                </Layout>
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Router>
    </MsalProvider>
  );
}

export default App;
